import { VanUtilityIcon } from './VanUtilityIcon';

/**
 * author: GreenTurtwig
 * id 517A8F96-14C9-4FAB-8AC2-27321C91E1BF
 * name van-utility
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/van-utility.svg
 * tags
 * - Transportation + Road 
 */
export const VanCandyIcon = VanUtilityIcon;
export default VanCandyIcon